"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acerno": {
    "8ff2b04f": [{
      "hkey": "5f4c7149",
      "slug": "acerno",
      "name": "Acerno",
      "primary": true,
      "skipSearch": false
    }],
    "le-croci": [{
      "hkey": "5f4c7149",
      "slug": "acerno",
      "name": "Acerno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9119d86a": [{
      "hkey": "5f4c7149",
      "slug": "acerno",
      "name": "Acerno",
      "primary": true,
      "skipSearch": false
    }],
    "piano-del-gaudo": [{
      "hkey": "5f4c7149",
      "slug": "acerno",
      "name": "Acerno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;